import dataApplicationsContext from '../../context/dataApplicationsContext';
import axios from "axios";
import { useContext, useRef, useState, useEffect, CSSProperties  } from 'react';
import { faCheck, faTimes, faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate, Link, useLocation } from 'react-router-dom';
import { useForm, useFieldArray, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';

import SyncLoader from "react-spinners/SyncLoader";

import { useDispatch } from 'react-redux';
import { setCredentials } from './authSlice';
import { useLoginMutation } from './authApiSlice';

function ModalLogin({}) {
  const { auth, setAuth, setOpenModal, windowWidth, setIsConnected } = useContext(dataApplicationsContext);

  const [passwordType, setPasswordType ] = useState('password');
  const [flashError, setFlashError ] = useState(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [login, { isLoading }] = useLoginMutation();

  const schema = yup.object().shape({
    email: yup
      .string()
      .required('Veuillez renseigner votre login'),
    password: yup
      .string()
      .required('Veuillez saisir votre mot de passe phrase')
  });

  const defaultValues = {
    email: process.env.REACT_APP_EMAIL ?? '',
    password: process.env.REACT_APP_PWD ?? '',
  }

  const form = useForm({ defaultValues, resolver: yupResolver(schema) });

  const { register, control, watch, setValue, handleSubmit, formState, reset, setFocus, clearErrors } = form;
  const { errors, isSubmitting, isSubmitSuccessful } = formState;

  const onSubmit = async (data) => {
    const { email, password } = data;
    try {
      const { accessToken, user } = await login({ email, password }).unwrap();
      dispatch(setCredentials({ accessToken }));
      setAuth({ 
        user, accessToken: user.accessToken 
      });
      setIsConnected(true)
      setOpenModal(false);
    } catch (error) {
      console.log(error);
      setFlashError(error.data?.message || "Erreur de connexion");
    }
  }
  

  const togglePassword =()=>{
    if (passwordType ==="password") {
      setPasswordType("text")
      return;
    }
    setPasswordType("password")
  }

  const cleanInput = () => {
    clearErrors();
  }

  const closeModalOnClickOnBG = (e) => {
    if (e.target.className === "modalBackground") {
      cleanInput()
      setOpenModal(false)
    }
  }

  const closeModalClean = () => {
    cleanInput();
    setOpenModal(false)
  }

  if (windowWidth < 781) {
    return (
      <div className="modalBackground" onClick={closeModalOnClickOnBG}>
        <div className="modal-container-login">
          <div className="close-container" onClick={closeModalClean}>
            <div className="leftright"></div>
            <div className="rightleft"></div>
            <label className="close-modal">fermé</label>
          </div>
          <form onSubmit={handleSubmit(onSubmit)} noValidate className='form-login'>
            <div className="modal-body-login">
              <div className="right-part">
                <div className="right-part-container">
                  <h2>Connection à l'application</h2>
                  {flashError && <p className='text-lg font-semibold mb-4 text-red-600'>{flashError}</p>}
                  <div className="inputs-login">
                    <label htmlFor="accountName">
                      adresse e-mail : 
                    </label>
                    <div className="input-accountName">
                      <input  
                        type="text" className={`login-input  clear-input mb-4 ${errors['email'] ? 'border-error' : ''}`} autoComplete="off" id='email' required
                        {...register('email')}
                      />
                      {errors['email'] && <p className='error-msg'><FontAwesomeIcon icon={faInfoCircle} className='mr-8'/>{errors['email'].message}</p>}
                    </div>

                    
                    <div className="input-password">
                      <div className={`pwd-label`}>
                        <div className="pwd-left-part">
                          <label htmlFor="password">Mot de passe :</label>
                          { passwordType === "password" 
                            ? <i className={`bi bi-eye-slash toggleEye`} id="togglePassword" onClick={togglePassword}></i> 
                            : <i className={`bi bi-eye toggleEye`} id="togglePassword" onClick={togglePassword}></i>
                          }
                        </div>
                      </div>
                      <input  
                        type={passwordType} autoComplete="off" id="password"  aria-describedby="pwdnote"
                        className={`login-input clear-input mb-4 ${errors['password'] ? 'border-error' : ''}`}
                        {...register('password')}
                      />
                      {errors['password'] && <p className='error-msg'><FontAwesomeIcon icon={faInfoCircle} className='mr-8'/>{errors['password'].message}</p>}
                    </div>
                  </div>
                  <div className="part-submit mt-8">
                    <button disabled={isSubmitting} type="submit" className={`btn-seConnecter`}>Se connecter</button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    )
  }


  return (
    <div className="modalBackground" onClick={closeModalOnClickOnBG}>
      <div className="modal-container-login">
        <div className="close-container" onClick={closeModalClean}>
          <div className="leftright"></div>
          <div className="rightleft"></div>
          <label className="close-modal">fermé</label>
        </div>
        <form onSubmit={handleSubmit(onSubmit)} noValidate>
          <div className="modal-body-login">
            <img src="/images/login-img-2.svg" alt="login-illustration" className="login-img login-img-lg"/>
            <img src="/images/login-img-croped-2.svg" alt="login-illustration" className="login-img login-img-sm"/>
            <div className="left-part">
              <img src="/images/logo_cgv_blanc.svg" alt="logo-gifi" className="login-logo"/>
              <h1 className="login-title">Connecte-toi et découvre toutes les fonctionnalités qui s’ouvrent à toi !</h1>
            </div>
            <div className="right-part">
              <div className="right-part-container">
                <h2>Connection à l'application</h2>
                {flashError && <p className='text-lg font-semibold mb-4 text-red-600'>{flashError}</p>}
                <div className="inputs-login">
                  <label htmlFor="accountName">
                    adresse e-mail : 
                  </label>
                  <div className="input-accountName">
                    <input  
                      type="text" className={`login-input  clear-input mb-4 ${errors['email'] ? 'border-error' : ''}`} autoComplete="off" id='email' required
                      {...register('email')}
                    />
                    {errors['email'] && <p className='error-msg'><FontAwesomeIcon icon={faInfoCircle} className='mr-8'/>{errors['email'].message}</p>}
                  </div>

                  
                  <div className="input-password">
                    <div className={`pwd-label`}>
                      <div className="pwd-left-part">
                        <label htmlFor="password">Mot de passe :</label>
                        { passwordType === "password" 
                          ? <i className={`bi bi-eye-slash toggleEye`} id="togglePassword" onClick={togglePassword}></i> 
                          : <i className={`bi bi-eye toggleEye`} id="togglePassword" onClick={togglePassword}></i>
                        }
                      </div>
                    </div>
                    <input  
                      type={passwordType} autoComplete="off" id="password"  aria-describedby="pwdnote"
                      className={`login-input clear-input mb-4 ${errors['password'] ? 'border-error' : ''}`}
                      {...register('password')}
                    />
                    {errors['password'] && <p className='error-msg'><FontAwesomeIcon icon={faInfoCircle} className='mr-8'/>{errors['password'].message}</p>}
                  </div>
                </div>
                <div className="part-submit mt-8">
                  <button disabled={isSubmitting} type="submit" className={`btn-seConnecter`}>Se connecter</button>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}

export default ModalLogin
